<template>
  <div>
    <filters-bar
    title="Cartera"
    title-class="headline"
    :filters="filters"
    :has-date-type="false"
    @search="setFilters">
    </filters-bar>
    <v-layout row wrap pa-0 ma-0 justify-end>
      <p class="caption" v-if="date">
          Ultima actualización {{ date }}
        </p>
    </v-layout>
    <v-layout row wrap>
      <!-- <v-flex md3>
        <v-layout row wrap class="f1-3em white elevation-2 mb-3 hovereable" 
          @click="openStatusReport(collection.position, collection.descrip === 'Total' ? 'all' : collection.descrip)" 
          v-for="(collection, i) in collections" 
          :key="i">
          <v-flex md21 class="pt-2 pb-2 pl-3 b-borders k-orange-linear">
            <v-layout justify-center align-center>
              <v-flex md5>
                {{collection.descrip}}
              </v-flex>
              <v-flex md7 class="text-xs-right pr-3">
                {{collectionTotal[0] !== undefined ? collection.descrip !== 'Total' ? `${Math.round(collection.quantity / collectionTotal[0].quantity * 100)}%` : '' : ''}}
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex md12 class="py-2">
            <v-layout row wrap class="px-3">
              <v-flex md6>
                Deudores
              </v-flex>
              <v-flex md6 class="text-xs-right">
                {{new Intl.NumberFormat('es-VE').format(collection.quantity)}}
              </v-flex>
            </v-layout>
            <v-layout row wrap class="px-3">
              <v-flex md4>
                Monto
              </v-flex>
              <v-flex md8 class="text-xs-right">
                ${{new Intl.NumberFormat('es-VE').format(collection.amount)}}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex> -->
      <v-flex md12>
        <v-card height="520px">
          <v-card-text>
            <v-list>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-subheader class="f1-5em">Gestionando</v-subheader>
                  <template v-if="manageds.length > 0">
                    <vue-perfect-scrollbar class="customer-status--scrollbar">
                      <v-list-tile class="b-borders ml-4" v-for="(manageds, i) in manageds" :key="i">
                        <v-layout row wrap class="f0-9em">
                          <v-flex md6>
                            <v-icon small class="pr-3">fas fa-{{ showIconChannel(manageds.channel_id) }}</v-icon>
                            {{ showNameChannel(manageds.channel_id) }}
                          </v-flex>
                          <v-flex md6 class="pl-4">
                            {{new Intl.NumberFormat('es-VE').format(manageds.quantity)}}
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-list-tile @click="openStatusReport(4, 'all')" class="ml-4">
                        <v-layout row wrap class="f0-9em">
                          <v-flex md6>
                            <strong>Total</strong>
                          </v-flex>
                          <v-flex md6 class="pl-4">
                            {{new Intl.NumberFormat('es-VE').format(managedTotal)}}
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                    </vue-perfect-scrollbar>
                  </template>
                  <template v-else>
                    <v-list-tile>
                      <v-layout row wrap>
                        <v-flex md12 class="text-xs-center">
                          No se encontraron resultados
                        </v-flex>
                      </v-layout>
                    </v-list-tile>
                  </template>
                </v-flex>
                <v-flex xs12 md6>
                  <v-subheader class="f1-5em">No gestionados</v-subheader>
                  <template v-if="unmanageds.length > 0">
                    <vue-perfect-scrollbar class="customer-status--scrollbar">
                      <v-list-tile class="b-borders ml-4" v-for="(unmanaged, i) in unmanageds" :key="i">
                        <v-layout row wrap class="f0-9em">
                          <v-flex md6>
                            <v-icon small class="pr-3">fas fa-{{ getCustomerField('id', unmanaged.customer_status_id, 'icon') }}</v-icon>
                            {{ getCustomerField('id', unmanaged.customer_status_id, 'status') }}
                          </v-flex>
                          <v-flex md6 class="pl-4">
                            {{new Intl.NumberFormat('es-VE').format(unmanaged.quantity)}}
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-list-tile @click="openStatusReport(5, 'all')" class="ml-4">
                        <v-layout row wrap class="f0-9em">
                          <v-flex md6>
                            <strong>Total</strong>
                          </v-flex>
                          <v-flex md6 class="pl-4">
                            {{new Intl.NumberFormat('es-VE').format(unmanagedTotal)}}
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                    </vue-perfect-scrollbar>
                  </template>
                  <template v-else>
                    <v-list-tile>
                      <v-layout row wrap>
                        <v-flex md12 class="text-xs-center">
                          No se encontraron resultados
                        </v-flex>
                      </v-layout>
                    </v-list-tile>
                  </template>
                </v-flex>
              </v-layout>
            </v-list>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import EventBus from '@/event-bus';
import moment from 'moment';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import reportsListMixin from '@/mixins/reportsList';
import formatDateMixin from '@/mixins/formatDate';
import channelMixin from '@/mixins/channels';
import statusMixin from '@/mixins/status';
import FiltersBar from '@/components/global/FiltersBar';


const qs = require('qs');

export default {
  mixins: [
    statusMixin,
    channelMixin,
    formatDateMixin,
    reportsListMixin,
  ],
  props: ['date'],
  components: {
    VuePerfectScrollbar,
    FiltersBar,
  },
  data() {
    return {
      manageds: [],
      unmanageds: [],
      report: [],
      collections: [
        {
          descrip: 'Por cobrar',
          quantity: 0,
          amount: 0,
          position: 1,
        },
        {
          descrip: 'Cobrado',
          quantity: 0,
          amount: 0,
          position: 1,
        },
        {
          descrip: 'Total',
          quantity: 0,
          amount: 0,
          position: 1,
        },
      ],
      filters: {
        date: moment().format('YYYY-MM-DD'),
        dateType: 'date',
      },
    };
  },
  mounted() {
    this.getReport();
  },
  computed: {
    /* eslint-disable */
    managedTotal() {
      let total = 0;
      if (this.manageds.length > 0) {
        this.manageds.forEach((managed) => {
          total += parseInt(managed.quantity);
        });
      }
      return total;
    },
    managedTotalAmount() {
      let total = 0;
      if (this.manageds.length > 0) {
        this.manageds.forEach((managed) => {
          total += parseInt(managed.amount);
        });
      }
      return total;
    },
    unmanagedTotal() {
      let total = 0;
      if (this.unmanageds.length > 0) {
        this.unmanageds.forEach((unmanaged) => {
          total += parseInt(unmanaged.quantity);
        });
      }
      return total;
    },
    unmanagedTotalAmount() {
      let total = 0;
      if (this.unmanageds.length > 0) {
        this.unmanageds.forEach((unmanaged) => {
          total += parseInt(unmanaged.amount);
        });
      }
      return total;
    },
    collectionTotal() {
      return this.collections.filter(collection => collection.descrip === 'Total');
    },
    /* eslint-enable */
  },
  methods: {
    openStatusReport(position, name) {
      const firstObject = {
        position,
        name,
        assigned: 1,
      };

      const filters = { ...firstObject, ...this.filters };
      EventBus.$emit('downloadReport', `Reporte de deudores ${name && name !== 'all' ? name.toLowerCase() : ''}`,
        '/customers',
        'customerStatusList',
        filters,
        'customers',
      );
    },
    getReport() {
      this.axios.get(`/reports?${qs.stringify(this.filters)}&type=daily`).then((response) => {
        if (response.data) {
          this.manageds = response.data.managed;
          this.unmanageds = response.data.unmanaged;
        } else {
          this.manageds = [];
          this.unmanageds = [];
        }
      });
    },
    setFilters(filters) {
      this.filters = {
        ...this.filters,
        ...filters,
      };
    },
    openSidebar() {
      EventBus.$emit(this.sidebarBus.open);
    },
  },
  watch: {
    'filters'() { // eslint-disable-line
      this.getReport();
    },
  },
};
</script>

<style scoped>
.customer-status--scrollbar {
  max-height: 350px;
  min-height: 350px;
}

.customer-status-none--scrollbar {
  max-height: 255px;
  min-height: 255px;
}

.hovereable:hover {
  cursor:pointer;
  background: rgba(0, 0, 0, .05) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/panel/info_schedules/WalletByCustomers.vue